import { render, staticRenderFns } from "./KitchenSinkUserFormGroup.vue?vue&type=template&id=0b233fe0&"
import script from "./KitchenSinkUserFormGroup.vue?vue&type=script&lang=ts&"
export * from "./KitchenSinkUserFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports